import { RichText } from '@/components/rich-text';
import { DisclaimerTrigger } from '../elements/disclaimer-trigger';

export const Disclaimer1a = ({
    hideTrigger,
    description,
    title,
    theme,
    attr,
}) => {
    return (
        <div className={`disclaimer bg-${theme}`} {...attr}>
            <DisclaimerTrigger hideTrigger={hideTrigger} title={title}>
                <div className="disclaimer__head">
                    <h4 className="disclaimer__title">{title}</h4>
                </div>
                {description && (
                    <RichText
                        className="disclaimer__description"
                        data={description}
                    />
                )}
            </DisclaimerTrigger>
        </div>
    );
};
